export class CallerIdLogCreateRequestModel {

  phoneNumber?: string;
  channelType?: string;
  internalNo?: string;
  isIncomingCall?: boolean;
  isDone?: boolean;
}
